import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-admin-zaroertekeles',
  templateUrl: './zaroertekeles.component.html',
  styleUrls: ['./zaroertekeles.component.scss'],
})
export class AdminZaroertekelesComponent implements OnInit {
  sajatIntezmeny: any;
  zaroBeallitas = {
    felevi_lathato_tol: '',
    evvegi_lathato_tol: '',
  };

  constructor(private data: DataService, private http: HttpClient) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.loadZaroBeallitas();
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  private normalizeDate(value: any): string {
    if (!value) return '';
    return String(value).slice(0, 10);
  }

  loadZaroBeallitas() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.http.get<any>('/api/ertekeles-zaro/beallitas/' + this.intezmenyPath()).subscribe({
      next: (response) => {
        this.zaroBeallitas = {
          felevi_lathato_tol: this.normalizeDate(response?.felevi_lathato_tol),
          evvegi_lathato_tol: this.normalizeDate(response?.evvegi_lathato_tol),
        };
      },
      error: (error) => {
        console.error('Záróértékelés láthatósági beállítás betöltési hiba:', error);
        this.data.sendToast('Nem sikerült betölteni a beállításokat.', 'error');
      },
    });
  }

  saveZaroBeallitas() {
    this.http.put('/api/ertekeles-zaro/beallitas/' + this.intezmenyPath(), this.zaroBeallitas).subscribe({
      next: () => this.data.sendToast('A záróértékelések láthatósági beállításai mentve.', 'success'),
      error: (error) => {
        console.error('Záróértékelés láthatósági beállítás mentési hiba:', error);
        this.data.sendToast('Nem sikerült menteni a láthatósági beállításokat.', 'error');
      },
    });
  }
}
